module.exports = __webpack_public_path__ + "assets/img/djrw.9584b9b8.png";